import { createRoute } from '@tanstack/react-router';
import { rootRoute } from 'routes/rootRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

// Kept for backward compatibility with sent emails
export const labOldSecuredClaimRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/lab/claims/$id',
  params: z.object({ id: zodPathParamId }),
  validateSearch: z.object({
    auth_token: z.string(),
  }),
}).lazy(() =>
  import('pages/secured/Claims/OldSecuredLabClaimPage/OldSecuredLabClaimPage').then((d) => d.Route)
);
